import api from "../../api";

export default {
  async getProjectFiles({ commit }, id_project) {
    try {
      const response = await api.get(
        `/new-kambuchi/projects/${id_project}/files`
      );

      if (!response.ok) {
        commit("setSnackbar", {
          text: response.error || "Unexpected error while getting files",
          enabled: true,
        });
      }
      return response;
    } catch (error) {
      console.error("Error in getProjectFiles action:", error);
      throw error;
    }
  },

  async uploadProjectFiles({ commit }, { id_project, files }) {
    try {
      const formData = new FormData();
      files.forEach((file) => formData.append("files", file));

      const response = await api.upload(
        `/new-kambuchi/projects/${id_project}/files`,
        formData
      );

      if (!response.ok) {
        commit("setSnackbar", {
          text: response.error || "Unexpected error while uploading files",
          enabled: true,
        });
      }
      return response;
    } catch (error) {
      console.error("Error in uploadProjectFiles action:", error);
      throw error;
    }
  },

  async getProjectFileDownloadUrl({ commit }, { id_project, id_file }) {
    try {
      const response = await api.get(
        `/new-kambuchi/projects/${id_project}/files/${id_file}/download`
      );

      if (!response.ok) {
        commit("setSnackbar", {
          text: response.error || "Unexpected error while downloading file",
          enabled: true,
        });
      }
      return response;
    } catch (error) {
      console.error("Error in getProjectFileDownloadUrl action:", error);
      throw error;
    }
  },

  async deleteProjectFile({ commit }, { id_project, id_file }) {
    try {
      const response = await api.delete(
        `/new-kambuchi/projects/${id_project}/files`,
        id_file
      );

      if (!response.ok) {
        commit("setSnackbar", {
          text: response.error || "Unexpected error while deleting file",
          enabled: true,
        });
      }
      return response;
    } catch (error) {
      console.error("Error in deleteProjectFile action:", error);
      throw error;
    }
  },
};
